import React from "react";
import { WHATSAPP_URL } from "../data/content";

export default function WhatsAppFloat({ cartCount = 0, onOpenCart }) {
  return (
    <>
      <button
        type="button"
        className="cart-float"
        onClick={onOpenCart}
        aria-label="View cart"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="24"
          height="24"
          aria-hidden="true"
        >
          <path d="M6 6h15l-1.5 9h-12z" />
          <path d="M6 6l-2-2H2" />
          <circle cx="9" cy="20" r="1.5" />
          <circle cx="18" cy="20" r="1.5" />
        </svg>
        {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
      </button>
      <a
        href={WHATSAPP_URL}
        className="wa-float"
        target="_blank"
        rel="noopener noreferrer"
        title="Order on WhatsApp"
        aria-label="Order on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="bubbleBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4fd8ff" />
              <stop offset="100%" stopColor="#5ac6ff" />
            </linearGradient>
            <linearGradient
              id="bubbleGreen"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#7af4b8" />
              <stop offset="100%" stopColor="#8ce5a5" />
            </linearGradient>
          </defs>
          <g filter="drop-shadow(0 6px 12px rgba(0,0,0,0.12))">
            <path
              d="M22.5 8.5c-1.65 0-3.24.54-4.5 1.45a8.76 8.76 0 0 0-5.66-1.92C8.24 8.03 5 11.28 5 15.5c0 1.8.7 3.45 1.96 4.71L6 24l4.08-1.2a8.88 8.88 0 0 0 5.42 1.67c4.22 0 7.67-3.24 7.67-7.24 0-4-3.45-7.23-7.67-7.23z"
              fill="url(#bubbleBlue)"
            />
            <path
              d="M24.7 13.8a6.44 6.44 0 0 0-5.2-2.8c-1.72 0-3.34.7-4.53 1.96-.5.52-.95 1.15-1.25 1.88a.75.75 0 0 0 .21.8l1.85 1.85a.75.75 0 0 1 .05 1.06c-.18.22-.53.45-.87.55a.75.75 0 0 1-.92-.4 3.98 3.98 0 0 1-.58-1.86c0-2.2 1.74-4 3.9-4a4 4 0 0 1 2.92 1.2 4.1 4.1 0 0 1 1.16 2.9c0 2.2-1.74 4-3.9 4-.34 0-.68-.05-1-.16a.75.75 0 0 1-.49-.93l.28-1.1a.75.75 0 0 0-.17-.7l-1.83-1.83a.75.75 0 0 1 .04-1.06c.38-.4.95-.86 1.52-1.2a7.44 7.44 0 0 1 2.9-1.05 6.34 6.34 0 0 1 6.17 3.73c.44 1 .66 2.05.66 3.12 0 1.94-.73 3.8-2.04 5.24a1 1 0 0 1-1.56.06l-1.6-1.74a2.55 2.55 0 0 1-.31-3.22c.07-.1.14-.2.22-.29.25-.26.63-.39 1.03-.33.4.06.9.16 1.48.16 1.78 0 3.24-1.43 3.24-3.21 0-.95-.37-1.85-1.03-2.48z"
              fill="url(#bubbleGreen)"
              opacity="0.95"
            />
          </g>
          <circle cx="12.5" cy="14.5" r="1.25" fill="#fff" />
          <circle cx="16" cy="14.5" r="1.25" fill="#fff" />
          <circle cx="19.5" cy="14.5" r="1.25" fill="#fff" />
        </svg>
      </a>
    </>
  );
}
